import React from 'react'
import { useDelistWarningToggle } from '../../state/application/hooks'
import Warning from './Warning'

export default function DelistBLTWarning({ displayOrder, setClose }: { displayOrder: number; setClose: () => void }) {
  const toggleDelistWarning = useDelistWarningToggle()

  return (
    <Warning
      closeWarning={() => {
        toggleDelistWarning(false)
        setClose()
      }}
      content={
        <>
          <b>[Action Required] BLT Teleport Service Ends on May 21</b>
          <br />
          To improve service for all Blocto users, the{' '}
          <b>BLT Teleport service will be sunset on May 21 at 9:00 AM (UTC+0)</b>.
          <br />
          Please ensure you complete any teleport transactions <b>before May 21</b>. After this date,{' '}
          <b>BLT teleport will no longer be available</b>.
          <br />
          For assistance, contact us at <a href="mailto:support@blocto.app">support@blocto.app</a>. We&apos;re here to
          help.
        </>
      }
      displayOrder={displayOrder}
      colorScheme="yellow"
    />
  )
}
